import { createSelector } from 'reselect'
export const getConfig = (state: RootState) => state.config


export const getControlId = createSelector(
    getConfig, config => {
        const controlId = typeof (config.scoreboardTypeId) === 'object' ? (config.scoreboardTypeId as { controlId: number }).controlId : config.controlId;
        return controlId;
    }
)
export const getApiPollingTimeInterval = (state: RootState) => state.apiPolling && state.apiPolling.timeInterval

export const getScoreboardTypeId = createSelector(
    getConfig, config => {
        const scoreboardTypeId = typeof (config.scoreboardTypeId) === 'object' ? (config.scoreboardTypeId as { scoreboradType: number }).scoreboradType : config.scoreboardTypeId;
        return scoreboardTypeId;
    }
)

export const getAmbassadorConfiguration = (state: RootState) =>
    state.ambassador

export const getLeaderboardConfiguration = (state: RootState) =>
    state.leaderboard

export const getMapConfiguration = (state: RootState) => state.mapVisualizer

export const getDonorRollConfiguration = (state: RootState) => state.donorRoll

export const getAffiliationConfiguration = (state: RootState) =>
    state.affiliation

export const getDashboardConfiguration = (state: RootState) => state.dashboard

export const getViewChallengesConfiguration = (state: RootState) => state.viewchallenge

export const getMapSettings = createSelector(
    getMapConfiguration, mapVisualizer => mapVisualizer && mapVisualizer.instanceSettings
)

export const getAmbassadorSettings = createSelector(
    getAmbassadorConfiguration, abConfig => abConfig && abConfig.instanceSettings
)

export const getLeaderboardSettings = createSelector(
    getLeaderboardConfiguration, lbConfig => lbConfig && lbConfig.instanceSettings
)

export const getDonorRollSettings = createSelector(
    getDonorRollConfiguration, donorRollConfig => donorRollConfig && donorRollConfig.instanceSettings
)

export const getAffiliationSettings = createSelector(
    getAffiliationConfiguration, affiliationConfig => affiliationConfig && affiliationConfig.instanceSettings
)

export const getDashboardSettings = createSelector(
    getDashboardConfiguration, dashboardConfig => dashboardConfig && dashboardConfig.instanceSettings
)

export const getViewChallengeSettings = createSelector(
    getViewChallengesConfiguration, viewchallengeConfig => viewchallengeConfig && viewchallengeConfig.instanceSettings
)
export const getInstanceSettings = createSelector(
    getScoreboardTypeId,
    getMapSettings,
    getLeaderboardSettings,
    getDonorRollSettings,
    getAffiliationSettings,
    getDashboardSettings,
    getAmbassadorSettings,
    getViewChallengeSettings,
    (
        typeId,
        mapSettings,
        leaderboardSettings,
        donorRollSettings,
        affiliationSettings,
        dashboardSettings,
        ambassadorSettings,
        viewchallengeSettings
    ) => {
        if (typeId > 0 && typeId < 5) {
            return mapSettings
        } else if ([5, 9].includes(typeId)) {
            return leaderboardSettings
        } else if (typeId === 6) {
            return donorRollSettings
        } else if (typeId === 7) {
            return affiliationSettings
        } else if (typeId === 8) {
            return dashboardSettings
        } else if (typeId === 10) {
            return ambassadorSettings
        } else if (typeId === 11) {
            return viewchallengeSettings
        } else if (typeId === 13) {
            return leaderboardSettings
        }
        return undefined
    }
)
